import { ajaxJson } from "../../imports/ajax";


export function sendBru_api(mobile) {
        return ajaxJson.post(`/users/get-number`,{phone:mobile})
}

